import { __rest, __assign } from '../../_virtual/_tslib.js';
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import Tippy from '@tippyjs/react/headless';
import useBreakpoint from '../../hooks/useBreakpoint.js';
import 'react-scrolllock';
import '../Modals/Modal/index.js';
import FancyModal from '../Modals/FancyModal/index.js';
import '../Modals/SimpleModal/index.js';
import '../Modals/FancyModal/FancyShowcase/index.js';
import '../Modals/FancyModal/FancyContent/index.js';
import '../Modals/Components/ModalTitle/index.js';
import '../Modals/Components/ModalFooter/index.js';
import '../Modals/Components/ModalContent/index.js';
import styles from './styles.css.js';

var HoverCard = function HoverCard(_a) {
  var children = _a.children,
      message = _a.message,
      title = _a.title,
      subTitleContent = _a.subTitleContent,
      footerContent = _a.footerContent,
      size = _a.size,
      hoverCardClassName = _a.hoverCardClassName,
      tippyChildClassName = _a.tippyChildClassName,
      variant = _a.variant,
      visible = _a.visible,
      rest = __rest(_a, ["children", "message", "title", "subTitleContent", "footerContent", "size", "hoverCardClassName", "tippyChildClassName", "variant", "visible"]);

  var _b = useState(visible || false),
      showBottomSheet = _b[0],
      setShowBottomSheet = _b[1];

  useEffect(function () {
    setShowBottomSheet(!!visible);
  }, [visible]);
  var isMobile = !useBreakpoint('sm');

  if (isMobile) {
    return React.createElement(React.Fragment, null, React.createElement(FancyModal, {
      isOpen: showBottomSheet,
      onRequestClose: function onRequestClose() {
        return setShowBottomSheet(false);
      }
    }, React.createElement(HoverCardWrapper, {
      variant: variant,
      title: title,
      message: message,
      subTitleContent: subTitleContent,
      footerContent: footerContent,
      size: size,
      hoverCardClassName: hoverCardClassName
    })), React.createElement("div", {
      onClick: function onClick() {
        return setShowBottomSheet(true);
      }
    }, children));
  } else {
    // Using <span> is hack so that the child doesn't need to use React.forwardRef()
    return React.createElement(Tippy, __assign({
      render: function render(attrs) {
        return React.createElement(HoverCardWrapper, {
          attrs: attrs,
          variant: variant,
          title: title,
          message: message,
          subTitleContent: subTitleContent,
          footerContent: footerContent,
          size: size,
          hoverCardClassName: hoverCardClassName
        });
      },
      visible: visible
    }, rest), React.createElement("span", {
      className: tippyChildClassName
    }, children));
  }
};

var HoverCardWrapper = function HoverCardWrapper(_a) {
  var _b;

  var attrs = _a.attrs,
      hoverCardClassName = _a.hoverCardClassName,
      title = _a.title,
      subTitleContent = _a.subTitleContent,
      footerContent = _a.footerContent,
      message = _a.message,
      _c = _a.variant,
      variant = _c === void 0 ? 'light' : _c,
      size = _a.size;
  return React.createElement("div", __assign({}, attrs, {
    className: classnames(styles.tooltip, hoverCardClassName, (_b = {}, _b[styles.light] = variant === 'light', _b[styles.dark] = variant === 'dark', _b[styles.small] = size === 'small', _b[styles.large] = size === 'large', _b))
  }), title && React.createElement("div", {
    className: styles.title
  }, title), subTitleContent && React.createElement(HoverCardContent, null, subTitleContent), message && React.createElement("div", {
    className: styles.message
  }, message), footerContent && React.createElement(HoverCardFooter, null, footerContent), React.createElement("span", {
    "data-popper-arrow": "",
    className: styles.arrow
  }));
};

var HoverCardFooter = function HoverCardFooter(_a) {
  var children = _a.children,
      className = _a.className;
  return React.createElement("div", {
    className: classnames(styles.footer, className)
  }, children);
};

var HoverCardContent = function HoverCardContent(_a) {
  var children = _a.children,
      className = _a.className;
  return React.createElement("div", {
    className: classnames(styles.content, className)
  }, children);
};

export default HoverCard;
//# sourceMappingURL=index.js.map
